function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { mapMutations, mapState } from 'vuex';
import ViewAttributeGroupComponent from '@/apps/attributes/components/ViewAttributeGroupComponent';
import EditAttributeGroupComponent from '@/apps/attributes/components/EditAttributeGroupComponent';
import { localPaginationMixin } from '@/mixins/local_pagination';
import search_engine_service from '@/apps/attributes/services/search_engine_service';
import tasks from '@/js/tasks';
export default {
  name: 'GroupAttribute',
  components: {
    ViewAttributeGroupComponent: ViewAttributeGroupComponent,
    EditAttributeGroupComponent: EditAttributeGroupComponent
  },
  mixins: [localPaginationMixin],
  data: function data() {
    return {
      DIALOG_VIEW_GROUP_ATTRIBUTE: 'DIALOG_VIEW_GROUP_ATTRIBUTE',
      DIALOG_EDIT_GROUP_ATTRIBUTE: 'DIALOG_EDIT_GROUP_ATTRIBUTE',
      DIALOG_DELETE_GROUP_ATTRIBUTE: 'DIALOG_DELETE_GROUP_ATTRIBUTE',
      Items: [],
      selected: {},
      filtro: {
        category_comma: '',
        q: ''
      },
      attributes_fields: []
    };
  },
  beforeMount: function beforeMount() {
    this.getAttributesGroups();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('attribute', ['setAttributes', 'addAtribute', 'removeAtribute'])), {}, {
    getAttributesGroups: function getAttributesGroups() {
      var _this = this;
      UseCasesService.getAttributesGroupsItems(this.companyCode).then(function (response) {
        if (response && response.data) {
          _this.Items = response.data.records;
        }
      });
    },
    addItem: function addItem(item) {
      this.selected = item;
      this.getAttributesFields();
    },
    EditItem: function EditItem(item, modalName) {
      this.selected = item;
      this.openDialog(modalName);
    },
    DeleteItem: function DeleteItem(item, modalName) {
      this.selected = item;
      this.openDialog(modalName);
    },
    viewItem: function viewItem(item, modalName) {
      this.selected = item;
      this.openDialog(modalName);
    },
    openDialog: function openDialog(modalName) {
      this.$refs[modalName].onOpen();
    },
    onCloseDialog: function onCloseDialog(modalName) {
      this.$refs[modalName].onClose();
      this.getAttributesGroups();
    },
    getAttributesFields: function getAttributesFields() {
      var _this2 = this;
      var listaAdicional = [];
      UseCasesService.getAttributesGroupsFields(this.companyCode, this.selected.id).then(function (response) {
        Object.values(response.data.attributes).map(function (item) {
          // console.log(item)
          _this2.filtro.category_comma = item.attribute_category;
          _this2.filtro.q = item.attribute_name;
          var aditional = search_engine_service.getBuscadorAtributosEspecifico(_this2.filtro);
          listaAdicional.push(aditional);
        });
        Promise.all(listaAdicional).then(function (values) {
          values.forEach(function (value) {
            _this2.editedItem = Object.assign({}, value.busqueda[0]);
            var test = _this2.attributes.findIndex(function (x) {
              return x.categoria == _this2.editedItem.categoria && x.nombre == _this2.editedItem.nombre;
            });
            if (test < 0) {
              _this2.editedItem.status = true;
              _this2.addAtribute(_this2.editedItem);
            }
          });
        });
      }).catch(function (err) {
        console.log(err);
        tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
      }).finally(function () {
        tasks.toast.success('Atributos agregados correctamente');
      });
    },
    onAceptarDelete: function onAceptarDelete(valor) {
      var _this3 = this;
      if (valor) {
        UseCasesService.deleteAttributeGroup(this.companyCode, this.selected.id).then(function (response) {
          if (response.code === 200) {
            _this3.onCloseDialog(_this3.DIALOG_DELETE_GROUP_ATTRIBUTE);
            tasks.toast.success('Grupo eliminado con éxito.');
          }
        }, function (err) {
          tasks.lockScreen.unlock();
          console.log(err);
        });
      }
      this.item_delete = null;
    }
  }),
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), mapState('attribute', ['attributes'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('attributes.label.this_is_the_list_attributes'),
        disabled: true
      }];
    },
    headers: function headers() {
      return [{
        text: this.translate('attributes.group.name'),
        align: 'start',
        sortable: false,
        value: 'preference_group_name'
      }, {
        text: this.translate('attributes.group.definition'),
        align: 'start',
        value: 'group_description'
      }, {
        text: this.translate('attributes.group.quantity'),
        align: 'end',
        value: 'attribute_count'
      }, {
        text: this.translate('attributes.group.owner'),
        align: 'start',
        value: 'email'
      }, {
        text: '',
        align: 'end',
        value: 'actions'
      }];
    }
  })
};